const REACT_APP_API = process.env.REACT_APP_API_URL;
const API_URL = `${REACT_APP_API|| ""}/api/domaine_doms`
export async function getDomains(url = API_URL) {
    const res = await fetch(url, { credentials: "include" });
    const data = await res.json();

    return {
        items: data.member || []
    };
}

export async function getDomainByID(url = API_URL, id ) {
    const res = await fetch(`${url}/${id}`, { credentials: "include" });
    const data = await res.json();

    return data;
}

export async function addDomain(domain) {
    const res = await fetch(API_URL, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/ld+json" },
        body: JSON.stringify(domain),
    });
    return await res.json();
}

export async function updateDomain(id, domain) {
    const res = await fetch(`${API_URL}/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/ld+json" },
        body: JSON.stringify(domain),
    });
    return await res.json();
}

export async function deleteDomain(id) {
    return fetch(`${API_URL}/${id}`, { method: "DELETE", credentials: "include" });
}
